<template>
	<div class="iframe-container-box container">
		<div class="header">
			<rs-row>
				<rs-col :span="24">
					<div class="grid-content bg-purple-dark">
						<span style="margin-left: 10px">全账单缴费</span>
					</div>
				</rs-col>
			</rs-row>
		</div>
		<div class="main">

			<rs-row style="min-height: 600px">
				<div class="main_header">
					<div class="searchForm" style="margin-top:10px">
						<renderForm :list="ruleForm" size="small" :formData.sync="searchForm" ref="ruleFormRef"
							label-width='100%'>
							<rs-form-item label="合同号" slot="mallName">
								<rs-select @change="handleSearch" filterable v-model="searchForm.contractCode" placeholder="请选择">
									<rs-option v-for="item in Contract" :key='item.value' :label="item" :value="item">
									</rs-option>
								</rs-select>
							</rs-form-item>
							<rs-form-item label="账单类型" slot="Billtype">
								<rs-select @change='Billtypes'  filterable v-model="searchForm.itemCode" placeholder="请选择">
									<rs-option v-for="item in Billtype" :key='item.value' :label="item.value" :value="item.id">
									</rs-option>
								</rs-select>
							</rs-form-item>
							<rs-form-item label="缴费日期" slot="date">
								<rs-date-picker v-model="searchForm.beginDate " type="daterange" range-separator="-"
									start-placeholder="开始时间" :default-value="timeDefaultShow" end-placeholder="结束时间"
									size="mini" class="margin-right-10">
								</rs-date-picker>
							</rs-form-item>
						</renderForm>
						<div style="margin-left: 80%; position: relative; top: -45px">
							<rs-button type="primary" style="margin-left: 45px" size="small" @click="handleSearch">查询
							</rs-button>
							<rs-button type="text" size="small" @click="clear">重置</rs-button>
						</div>
					</div>
					<div class="contractCode">
						<div>
							<div>待缴总金额（元）</div>
							<div class="contractCodecolor">{{ amountpaid }} <span></span></div>
						</div>
						<div>
							<div>当期缴费金额(元)</div>
							<div>{{ Currentnumber }} <span></span></div>
						</div>
						<div>
							<div>已缴总金额（元）</div>
							<div>{{ PaidAmount }} <span></span></div>
						</div>
						<div>
							<div>缴费记录</div>
							<div>{{totalss}}</div>
						</div>
					</div>
				</div>
				<div class="main_main" style="background: #fff; box-shadow: 2px 2px 10px #909090;">
					<!-- <rs-row :gutter="24" style="height: 2%;margin-top:20px;padding:10px;padding-top:20px">
						<rs-col :span="12">
							<rs-row>
								<rs-button size="mini" :type="primaryButton" @click="wholeReception">待缴账单</rs-button>
								<rs-button size="mini" :type="primary" @click="wholeRecep">已缴账单</rs-button>
								<rs-button size="mini" :type="primaryliushui" @click="wholeRecepliushui">缴费流水
								</rs-button>
							</rs-row>
						</rs-col>
						<rs-col :span="11" :offset="1">
							<rs-button style="float: right; margin-left: 4%" plain @click="export2Excel">下载</rs-button>
							<rs-button style="float: right" type="primary" @click="confirmation()">缴费</rs-button>
						</rs-col>
					</rs-row> -->

					<!-- 操作栏 -->
					<rs-tabs style="margin-top: 10px" v-model="activeName" type="card" @tab-click="handleClick">
						<!-- <rs-col :span="23" :offset="1">
							<rs-button style="float: right; margin-left: 0%" plain @click="export2Excel">下载</rs-button>
					
						</rs-col> -->
						<rs-button style="float: right; margin-left: 0%;margin-right: 10px;margin-bottom: 10px;margin-top: 50px;"
							 @click="export2Excel">下载
						</rs-button>
						<rs-tab-pane label="待缴账单" name="first">
							<!-- <div class="operBox"></div> -->
							<!-- 表格 -->
							
							<div class="resultContent" style="margin-top: -45px;padding:10px">
								<renderTable class="row-click" :list="tableData" :columns="tableColumns" border
									ref="multipleTable" @row-dblclick="handleView"
									@selection-change="handleSelectionChange">
									<rs-table-column slot="selection" fixed type="selection" width="50px">
									</rs-table-column>
									<rs-table-column header-align='center' align='center' v-if='lonk' show-overflow-tooltip label="合同号" slot="contractCode" sortable>
										<template slot-scope="scope">
											<span @dbclick.stop="toDetails(scope.row.id)"
												style="cursor: pointer">{{ scope.row.contractCode }}</span>
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' label="铺位号" slot="buildingName">
										<template slot-scope="scope">
											{{ scope.row.boothCode }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' label="楼栋" slot="buildingName" >
										<template slot-scope="scope">
											{{ scope.row.buildingName }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' label="楼层" slot="floorName">
										<template slot-scope="scope">
											{{ scope.row.floorName }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' show-overflow-tooltip label="账单周期" slot="statementBeginEndTime"
										>
										<template slot-scope="scope">
											{{ scope.row.statementBeginEndTime }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' label="账单应收日" slot="paymentDue" >
										<template slot-scope="scope">
											{{ scope.row.paymentDue }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' label="应收金额（元）" slot="receivableAmount" >
										<template slot-scope="scope">
											{{ scope.row.unpaidAmount }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' show-overflow-tooltip label="费用项" slot="itemName" >
										<template slot-scope="scope">
											{{ scope.row.itemName }}
										</template>
									</rs-table-column>
									<rs-table-column label="操作" slot="operation" fixed="right" width="240px">
										<!-- <template slot-scope="scope"> </template> -->
									</rs-table-column>
								</renderTable>
					
								<!-- 分页 -->
								<rs-pagination style="padding: 20px;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
									:current-page="pageNum" :page-sizes="[10, 200, 300, 400]" :page-size="pageSize"
									background :prev-text="'上一页'" :next-text="'下一页'"
									layout="total,prev, pager, next, sizes, jumper" :total="total"></rs-pagination>
							</div>
						</rs-tab-pane>
						<rs-tab-pane label="已缴账单" name="second">
							<div class="operBox"></div>
							<!-- 表格 -->
							<div class="resultContent" style="margin-top: -45px;padding:10px">
								<renderTable class="row-click" :list="tableDatas" :columns="tableColumns" border
									ref="multipleTable" @row-dblclick="handleView"
									@selection-change="handleSelectionChange">
									<rs-table-column type="selection" width=""> </rs-table-column>
					
									<rs-table-column v-if='lonk' header-align='center' align='center' show-overflow-tooltip label="合同号" slot="contractCode" sortable      width="0px">
										<template slot-scope="scope">
											<span @dbclick.stop="toDetails(scope.row.id)"
												style="cursor: pointer">{{ scope.row.contractCode }}</span>
										</template>
									</rs-table-column> 
									<rs-table-column v-if="lonk" header-align='center' align='center' show-overflow-tooltip label="铺位号" slot="buildingName"      width="0px">
										<template slot-scope="scope">
											{{ scope.row.boothCode }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' show-overflow-tooltip label="楼栋" slot="buildingName"      width="0px">
										<template slot-scope="scope">
											{{ scope.row.buildingName }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' show-overflow-tooltip label="楼层" slot="floorName"      width="0px">
										<template slot-scope="scope">
											{{ scope.row.floorName }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' show-overflow-tooltip label="账单周期" slot="statementBeginEndTime"
										     width="0px">
										<template slot-scope="scope">
											{{ scope.row.statementBeginEndTime }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' show-overflow-tooltip label="付款日期" slot="paymentDue"      width="0px">
										<template slot-scope="scope">
											{{ scope.row.paymentDue }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' align='center' label="缴纳金额（元）" slot="receivableAmount"      width="0px">
										<template slot-scope="scope">
											{{ scope.row.paidAmt }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' show-overflow-tooltip align='center' label="费用项" slot="itemName"      width="0px">
										<template slot-scope="scope">
											{{ scope.row.itemName }}
										</template>
									</rs-table-column>
									<rs-table-column label="付款账户" header-align='center' align='center' slot="fu"      width="0px">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="收款账户" header-align='center' align='center' slot="sou"      width="0px">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="支付流水"header-align='center' align='center' slot="pay"      width="0px">
										<template slot-scope="scope">
											{{scope.row.payType }}
										</template>
									</rs-table-column>
									<rs-table-column label="支付方式" header-align='center' align='center' slot="paytype"      width="0px">
										<template slot-scope="scope">
											{{scope.row.payType }}
										</template>
									</rs-table-column>
								</renderTable>
					
								<!-- 分页 -->
								<rs-pagination style="padding: 20px;" @size-change="handleSizeChangess" @current-change="handleCurrentChangess"
									:current-page="pageNums" :page-sizes="[10, 200, 300, 400]" :page-size="pageSizes"
									background :prev-text="'上一页'" :next-text="'下一页'"
									layout="total,prev, pager, next, sizes, jumper" :total="totals"></rs-pagination>
							</div>
						</rs-tab-pane>
						<rs-tab-pane label="缴费流水" name="third">
							<div class="operBox"></div>
							<!-- 表格 -->
							<div class="resultContent" style="margin-top: -45px;padding:10px">
								<renderTable class="row-click" :list="tableDatass" :columns="tableColumns" border
									ref="multipleTable" @row-dblclick="handleView"
									@selection-change="handleSelectionChange">
									<!-- <rs-table-column type="selection" width="155px"> </rs-table-column> -->
									<rs-table-column v-if="lonk" header-align='center' show-overflow-tooltip align='center' label="铺位号" slot="buildingName"      width="0px">
										<template slot-scope="scope">
											{{ scope.row.booths }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' show-overflow-tooltip  align='center' label="楼栋" slot="buildingName" width="0px">
										<template slot-scope="scope">
											{{ scope.row.buildings }}
										</template>
									</rs-table-column>
									<rs-table-column v-if="lonk" header-align='center' show-overflow-tooltip  align='center' label="楼层" slot="floorName" width="0px">
										<template slot-scope="scope">
											{{ scope.row.floors }}
										</template>
									</rs-table-column>
									<rs-table-column label="支付金额(元)" header-align='center' align='center' slot="pay" width="0px">
										<template slot-scope="scope">
												{{scope.row.payAmt/100}}
										<!-- 	{{ scope.row.payAmt }} -->
										</template>
									</rs-table-column>
									<rs-table-column label="订单流水(商户单号)" show-overflow-tooltip header-align='center' align='center' slot="dingdan" width="0px">
										<template slot-scope="scope">
											{{ scope.row.merOrderNo }}
										</template>
									</rs-table-column>
									<rs-table-column label="交易流水" show-overflow-tooltip header-align='center' align='center' slot="jiaoyi" width="0px">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="银行流水" header-align='center' align='center' slot="yinhang" width="0px">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="支付方式"header-align='center' align='center' slot="paytype" width="0px">
										<template slot-scope="scope">
											{{scope.row.payType }}
										</template>
									</rs-table-column>
									<rs-table-column label="付款账户"header-align='center' align='center' slot="fu" width="0px">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="收款账户"header-align='center' align='center' slot="sou" width="0px">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column :formatter='formatCarModels' prop='tradeStatus' label="交易状态" header-align='center' align='center' slot="status" width="0px">
										<!-- <template slot-scope="scope">
											{{scope.row.tradeStatus }}
										</template> -->
									</rs-table-column>
									<rs-table-column label="支付时间"header-align='center' align='center' slot="times" width="0px">
										<template slot-scope="scope">
											{{ }}
										</template>
									</rs-table-column>
									<rs-table-column label="操作" slot="operation" fixed="right" width="240px">
										<!-- <template slot-scope="scope"> </template> -->
									</rs-table-column>
								</renderTable>
					
								<!-- 分页 -->
								<rs-pagination style="padding: 20px;" @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
									:current-page="pageNumss" :page-sizes="[10, 200, 300, 400]" :page-size="pageSizess"
									background :prev-text="'上一页'" :next-text="'下一页'"
									layout="total,prev, pager, next, sizes, jumper" :total="totalss"></rs-pagination>
							</div>
						</rs-tab-pane>
					
					</rs-tabs>
				</div>
				<rs-dialog title="确认" :visible.sync="dialogVisible" width="30%">
					<h2 style="text-align: center; margin: 0">
						{{ `确认${confirmType}吗？` }}
					</h2>
					<span slot="footer" class="dialog-footer">
						<rs-button @click="dialogVisible = false">取 消</rs-button>
						<rs-button type="primary" @click="confirm">确 定</rs-button>
					</span>
				</rs-dialog>
				<change-type-dialog :path="path" :contractId="contractId" :dialogVisible="showChangeTypeDialog" @close="
          () => {
            this.showChangeTypeDialog = false;
          }
        ">
				</change-type-dialog>
			</rs-row>
		</div>
		<rs-dialog title="支付" :visible.sync="dialogVisibles" width="30%" :before-close="handleClose">
			<h5>选择支付方式：</h5>
			  <rs-radio-group style="margin-top: 10px;" v-model="paymentType" @change="paymentTypeChange">
			                    <rs-radio  border :label="''+ 0">扫码支付</rs-radio>
			                    <rs-radio border :label="''+ 1">对公打款</rs-radio>
			                </rs-radio-group>
					
				</rs-dialog>
		<!-- 二维码弹框 -->
		<rs-dialog title='扫码支付' width='30%' :visible.sync="dialogVisibless" :before-close="handleClose">
			<div style="margin-top: 10px;" class="body-img" >
				<div id="qrcode" ref="qrcode"></div>
				<div style="text-align: center;height: 50px;line-height: 50px;border-radius: 10px;">请扫描上方二维码进行支付</div>
			</div>
			<div v-if="lnko" style="width:100%;text-align: center;height: 300px ;font-size: 30px;">
				<img style="width: 30%;" src="../assets/支付成功.png"/><br/>
				支付成功
			<rs-button  @click="dialogVisibles = false" type="primary" style="width:100%;float: right;border-radius:20px;margin-top: 80px;">完成</rs-button>
			</div>
			<div slot="footer" class="dialog-footer">
			    <rs-button @click="close">取 消</rs-button>
			  </div>
		</rs-dialog>
		<rs-dialog title='对公打款' width="30%" :visible.sync="dialogVisiblesss">
			<rs-form :model="paylist">
			    <rs-form-item label="商户订单号:" >
			     {{paylist.merOrderNo}}
			    </rs-form-item>
			    <rs-form-item label="商户编号:" >
			      {{paylist.merchantNumber}}
			    </rs-form-item>
				<rs-form-item label="子账户名称:" >
				  {{paylist.subActName}}
				</rs-form-item>
				<rs-form-item label="渠道子账户:" >
				  {{paylist.chlSubActNo}}
				</rs-form-item>
				<rs-form-item label="缴纳金额:" >
				  {{paylist.orderAmt}}
				</rs-form-item>
				<rs-form-item label="校验码:" >
				  {{paylist.checkCode}}
				</rs-form-item>
			  </rs-form>
			<div slot="footer" class="dialog-footer">
			    <rs-button @click="dialogVisiblesss = false">取 消</rs-button>
			  </div>
		</rs-dialog>
	</div>
</template>

<script>
	//二维码
	import VueQr from 'vue-qr'
	import QRCode from 'qrcodejs2';
	import Http from "@/api/api";
	import API from "@/api/pay";
	import utils from "@/utils/utils";
	import Export2Excel from '@/utils/Export2Excel';
	import Blob from '@/utils/Blob';
	// import detail from "../resourceManage/resourceDetail";
	export default {
		name: "resourceManage",
		components: {
			QRCode,
			 VueQr
		},
		data() {
			return {
				"paymentType": "",
				dialogVisibless:false,
				dialogVisiblesss: false,
				paylist:[],
				pink:true,
				lcnk:true,
				lnko:false,
					activeName: 'first',
				logoSrc:require('../assets/logo.png')	,	
				dialogVisibles: false,
				url: '',
				PayNum: 0,
				primaryButton: "primary",
				primary: "",
				primaryliushui: "",
				pickerOptions: {
					shortcuts: [{
							text: "最近一周",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit("pick", [start, end]);
							},
						},
						{
							text: "最近一个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit("pick", [start, end]);
							},
						},
						{
							text: "最近三个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit("pick", [start, end]);
							},
						},
					],
				},
				showChangeTypeDialog: false,
				path: "",
				contractId: "",
				tableData: [],
				tableDatas: [],
				tableDatass: [],
				Contract: [],
				Billtype: [
					{id:'1001',value:'租赁缴费'},
					{id:'1004',value:'物业缴费'},
					{id:'1101,1102',value:'水电费缴费'},
					{id:'7001',value:'定金缴费'}
					
				],
				// wholeReceptiontabData: [],
				// wholeRecepData: [],
				// wholeRecepliushuiData: [],
				// tableColumns: [],

				// ruleForm: [],
				// tmpRuleForm: [],
				pageNum: 1,
				pageSize: 10,
				pageNums: 1,
				pageSizes: 10,
				pageNumss: 1,
				pageSizess: 10,
				total: 0,
				totals: 0,
				totalss: 0,
				timeDefaultShow: [],
				searchForm: {
					contractCode: "",
					beginDate: [],
					shopId: "",
					itemCode: ""
				},
				searchFormClose: true,
				amountpaid: "",
				confirmType: "",
				dialogVisible: false,
				shopVo: {},
				updateTime: "",
				Currentnumber: "",
				PaidAmount: 0,
				categoryList: [],
				val: '',
				lists: [],
				gettimes:'',
				nums:'',
				lonk: true,
				link: false,
				merOrderNo:'',
				timer:'',
				itemCode:''
			};
		},
		watch: {
			searchMenuName(val) {
				console.log(val);
				this.$refs.resourceTree.filter(val);
			},
		},
		//生命周期 - 创建完成（访问当前this实例）
		created() {
			this.bus.$on('id',(num)=>{
				this.nums=num
			})
			this.bus.$on('val', (val) => {
				this.val = val
			})
			this.getTime()
			this.shopVo = sessionStorage.getItem("shopVo");
			// debugger
			let {
				auditStatusStr,
				mallCode
			} = this.$route.query;
			
			this.searchForm.auditStatusStr = auditStatusStr ? [1 * auditStatusStr] : [];
			this.searchForm.mallCode = mallCode || "";
			this.renderPage();
			if (
				this.$route.query.mallCode &&
				this.$route.query.contractStatus &&
				this.$route.query.days
			) {
				this.searchForm.contractStatusStr = Number(
					this.$route.query.contractStatus
				);
				this.searchForm.auditStatusStr= 2; //审核通过
				this.searchForm.mallCode = this.$route.query.mallCode;
				let days = Number(this.$route.query.days);
				if (this.$route.query.contractStatus == 4) {
					//待生效==查近期开始合同
					this.searchForm.beginDate =
						days > 0 ? [utils.dateFormatter(new Date()), this.getAfterParamsDate(days)] : [this
							.getAfterParamsDate(days), utils.dateFormatter(new Date())
						];
				} else if (this.$route.query.contractStatus == 1) {
					//已生效==查近期到期合同
					this.searchForm.endDates =
						days > 0 ? [utils.dateFormatter(new Date()), this.getAfterParamsDate(days)] : [this
							.getAfterParamsDate(days), utils.dateFormatter(new Date())
						];
				}
			}
		},
		//生命周期 - 挂载完成（访问DOM元素）
		mounted() {
			this.handleQueryy()
			this.handleQuery();
			// this.Bills();
			this.amountobepaid();
			this.Currentpayment();
			this.TotalPaidAmount();
			this.getPayRecordList();
			this.getTotalPaidAmount()
			// this.getTotalPaidAmount()
		},
		activated() {
			this.handleQuery();
		},
		methods: {
			formatCarModels(row, Status) {
				if (row.tradeStatus == "WAIT") {
					
					return "未支付";
				} else if(row.tradeStatus=='SUCCESS') {
					
					return "已支付";
				}
			},
			//支付方式
			           paymentTypeChange(val) {
			               this.paymentType = val
										console.log(val)
										if(Number(this.paymentType)=='0'){
											// this.lcnk=true
											this.dialogVisibless=true
											this.dialogVisibles=false
											this.pay()
										}else if(Number(this.paymentType)=='1'){
											this.dialogVisiblesss=true
											this.dialogVisibles=false
											this.Pay()
											// this.lcnk=false
										}
			           },
			handleClick(tab, index) {
				console.log(tab.index)
				localStorage.setItem('id', tab.index)
				if(tab.index=='1'){
					this.pink=false
					this.getTotalPaidAmount()
				}else if(tab.index=='2'){
					this.pink=false
					this.getPayRecordList()
				}else{
					this.pink=true
					this.handleQuery()
				}
			},
			// 列表API数据合同
			handleQueryy() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize: 999,
					pageNum,
					...this.searchForm,
					paidStatus: 0,
					businessId: this.shopVo,
				};
				params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.lists = res.data.data.list
							// this.tableData = res.data.data.list;
							console.log(res.data.data.list)
							// this.total = res.data.data.total;
							for (var i = 0; i < res.data.data.list.length; i++) {
								if (this.Contract.indexOf(res.data.data.list[i].contractCode) === -1) {
									this.Contract.push(res.data.data.list[i].contractCode)
								}
								// if (this.Billtype.indexOf(res.data.data.list[i].itemName) === -1) {
								// 	this.Billtype.push(res.data.data.list[i].itemName)
								// }
							}
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			getTime() {
				let starttime = new Date(new Date().toLocaleDateString())
				let endtime = new Date()
				this.timeDefaultShow.push(starttime)
				this.timeDefaultShow.push(endtime)
			},
			// toDetails(id) {
			//   this.$openTabSwitch(
			//     "合同详情",
			//     `/contractNew?actionType=view&contractType=${this.contractType}&contractId=${id}&fromPath=versionList`
			//   );
			// },

			//待缴账单
			wholeReception(e) {
				console.log(e)
				console.log(e.target.innerHTML)
				localStorage.setItem('index', e.target.innerHTML)
				this.primaryButton = "primary";
				this.primary = "";
				this.primaryliushui = "";
				//待缴账单
				this.handleQuery();
				// this.tableData = this.wholeReceptiontabData;
			},
			//已缴账单
			wholeRecep(e) {
				console.log(e)
				console.log(e.target.innerHTML)
				localStorage.setItem('index', e.target.innerHTML)
				this.primaryButton = "";
				this.primary = "primary";
				this.primaryliushui = "";
				//已缴账单
				this.getTotalPaidAmount();
				// this.tableData = this.wholeRecepData;
			},
			//缴费流水
			wholeRecepliushui(e) {
				console.log(e)
				console.log(e.target.innerHTML)
				localStorage.setItem('index', e.target.innerHTML)
				this.primaryButton = "";
				this.primary = "";
				this.primaryliushui = "primary";
				//缴费流水
				this.getPayRecordList();
				// this.tableData = this.wholeRecepliushuiData;
			},
			//下载生成excel
			formatJson(filterVal, jsonData) {
				return jsonData.map((v) => filterVal.map((j) => v[j]));
			},
			export2Excel() {
				require.ensure([], () => {
					const {
						export_json_to_excel
					} = require('../../../utils/Export2Excel');
					const tHeader = ['铺位号', '楼栋', '楼层', '账单周期', '账单应收日', '应收金额', '费用项', '合同号'];
					const filterVal = ['boothCode', 'buildingName', 'floorName', 'statementBeginEndTime',
						'paymentDue', 'unpaidAmount', 'itemName', 'contractCode'
					];
					const list = this.tableData;
					console.log(list)
					const data = this.formatJson(filterVal, list);
					export_json_to_excel(tHeader, data, '全部账单缴费');
				});
			},
			//

			getAfterParamsDate(params) {
				let date = new Date().getTime() + 24 * 60 * 60 * 1000 * params;
				date = utils.dateFormatter(date);
				return date;
			},
			// 查询
			handleSearch() {
				var num = 1
				this.bus.$emit('id', num)
				this.pageNum = 1
				// this.handleQuery();
				if (localStorage.getItem('id') == '0' || localStorage.getItem('id') == null) {
					this.handleQuery();
				} else if (localStorage.getItem('id') == '1') {
					this.getTotalPaidAmount()
				} else if (localStorage.getItem('index') == '2') {
					this.getPayRecordList()
					// this.getTotalPaidAmount()
				}
			},
			Billtypes(){
				console.log(this.tableData)
				if(this.searchForm.itemName=='租赁缴费'){
					this.itemCode="1001"
				}else if(this.searchForm.itemName=='物业缴费'){
					this.itemCode="1004"
				}else if(this.searchForm.itemName=='水电费缴费'){
					this.itemCode='1101,1102'
				}else if(this.searchForm.itemName=='定金缴费'){
					this.itemCode='7001'
				}
			},
			clear() {
				this.searchForm = {
					businessId: "",
					contractCode: "",
					beginDate: [],
					itemCode: ''
				};
			},
			handleQuerys() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				console.log(this.searchForm)
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					// ...this.searchForm,
					paidStatus: 0,
					businessId: this.shopVo,
				};
				params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表11", res.data.data.list);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			// 列表API数据
			handleQuery() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				console.log(this.searchForm)
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					paidStatus: 0,
					businessId: this.shopVo,
					// itemCode:this.itemCode
				};
				params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表11", res.data.data.list);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			turnParams(params) {
				console.log(params);
				if (params.beginDate && params.beginDate.length) {
					params.paymentDueBeginDate =
						typeof params.beginDate[0] == "object" ?
						utils.dateFormatter(params.beginDate[0], "yyyy-MM-dd") :
						params.beginDate[0];
					params.paymentDueEndDate =
						typeof params.beginDate[1] == "object" ?
						utils.dateFormatter(
							typeof params.beginDate[1] == "object" ?
							params.beginDate[1] :
							new Date(params.beginDate[1]),
							"yyyy-MM-dd"
						) :
						params.beginDate[1];
				} else {
					params.paymentDueBeginDate = "";
					params.paymentDueEndDate = "";
				}
				delete params.beginDate;
				if (params.endDates && params.endDates.length) {
					params.beginDate =
						typeof params.endDates[0] == "object" ?
						utils.dateFormatter(params.endDates[0], "yyyy-MM-dd") :
						params.endDates[0];
					params.endDate =
						typeof params.endDates[1] == "object" ?
						utils.dateFormatter(params.endDates[1], "yyyy-MM-dd") :
						params.endDates[1];
				} else {
					params.beginDate = "";
					params.endDate = "";
				}
				delete params.endDates;
				console.log(params);
				return params;
			},
			//获取已缴费清单
			getTotalPaidAmount() {
				let pageNum = this.pageNums;
				let pageSize = this.pageSizes;
				console.log(this.shopVo);
				// console.log(this.shopVo.shopId)
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					paidStatus: 1,
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableDatas = res.data.data.list;
							this.totals = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},
			//获取未缴费清单  （未缴费加上一个月时间）
			Bills() {
				let pageNum = this.pageNum;
				let pageSize = this.pageSize;
				console.log(this.shopVo);
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					// ...this.searchForm,
					businessId: this.shopVo,
					// shopId: this.shopVo,
					// paidStatus:0,
				};
				// params = this.turnParams(params);
				API.page(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表", res);
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},

			//缴费流水
			getPayRecordList() {
				let pageNum = this.pageNumss;
				let pageSize = this.pageSizess;
				console.log(this.shopVo.shopId);
				// console.log(this.searchForm, "kanakn");
				let params = {
					pageSize,
					pageNum,
					...this.searchForm,
					// paidStatus: 0,
					businessId: this.shopVo,
				};
				// params = this.turnParams(params);
				API.getPayRecordList(params)
					.then((res) => {
						if (res.data.code == 200) {
							console.log("获取合同列表缴费", res);
							this.tableDatass = res.data.data.list;
							this.totalss= res.data.data.total;
						}
					})
					.finally(() => {
						utils.hideLoading();
					});
			},

			//获取待缴费金额
			amountobepaid() {
				let params = {
					businessId: this.shopVo,
					paymentDueBeginDate: "",
					paymentDueEndDate: "",
					contractCode: this.searchForm.contractCode,
				};

				API.paygetTotalUnpaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表代缴", res);
						if(res.data.data==null){
							this.amountpaid=0
						}else{
							this.amountpaid = res.data.data;
						}
						
					}
				});
			},

			addDate() {
				// const nowDate = new Date();
				// const date = {
				//   year: nowDate.getFullYear(),
				//   month: nowDate.getMonth() + 2,
				//   date: nowDate.getDate(),
				// };
				// const newmonth = date.month > 10 ? date.month : "0" + date.month;
				// const day = date.date > 10 ? date.date : "0" + date.date;
				// const hh = new Date().getHours();
				// const mf = new Date().getMinutes()
				// const ss = new Date().getSeconds()
				var _this = this;
				// let yy = new Date().getFullYear();
				// let mm = new Date().getMonth()+1;
				// let dd = new Date().getDate();
				// let hh = new Date().getHours();
				// let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
				// let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
				var d = new Date();
				var ye = d.getFullYear();
				var mo = (d.getMonth() + 2).toString().padStart(2, '0');
				var mos = (d.getMonth() + 1).toString().padStart(2, '0');
				var da = d.getDate().toString().padStart(2, '0');
				var updateTime = ye + '-' + mo + '-' + da;
				var updateTimes = ye + '-' + mos + '-' + da;
				// alert(time);
				console.log((d.getMonth() + 2).toString().padStart(2, '0'))
				// _this.updateTime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
				_this.updateTime = updateTime
				_this.gettimes=updateTimes
				console.log(updateTime)
				// this.updateTime = date.year + "-" + newmonth + "-" + day + '' + hh;
			},

			//获取当期缴费金额   当前时间加一个月
			Currentpayment() {
				this.addDate();
				let updateTime = this.updateTime;
				let updateTimes = this.gettimes;
				console.log(updateTime);
				let time = Number(updateTime)
				// console.log(time)
				let params = {
					businessId: this.shopVo,
					paymentDueBeginDate: updateTimes,
					paymentDueEndDate: updateTime,
					contractCode: this.searchForm.contractCode,
				};
				// params = this.turnParams(params);
				API.paygetTotalUnpaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
							
						if(res.data.data==null){
							this.Currentnumber=0
						}else{
							this.Currentnumber = res.data.data;
						}
						
					}
				});
			},
			//获取已缴费金额
			TotalPaidAmount() {
				let params = {
					...this.searchForm,
					paidStatus: 1,
					businessId: this.shopVo,
				};

				API.getTotalPaidAmount(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						if (res.data.data == null) {
							this.PaidAmount = 0
						} else {
							this.PaidAmount = res.data.data;
						}

					}
				});
			},

			//获取
			handleSelectionChange(val) {
				this.bus.$emit('val', val)
				this.multipleSelection = val;
				console.log(this.multipleSelection);
				var categorystr = "";
				var classifystr = "";
				var classirerstr = "";
				this.multipleSelection.forEach(function(c) {
					categorystr += c.statementNo + ",";
					classifystr += c.itemCode + ",";
					classirerstr += c.businessId + ",";
				});
				categorystr = categorystr.substring(0, categorystr.length - 1);
				console.log(categorystr);
				classifystr = classifystr.substring(0, classifystr.length - 1);
				classirerstr = classirerstr.substring(0, classirerstr.length - 1);
				// this.categoryList = categorystr.split(",");
				// this.classifystr = classifystr.split(",");
				// this.classirerslist = classirerstr.split(",");
				this.categoryList = categorystr;
				this.classifystr = classifystr;
				this.classirerslist = classirerstr;
				// console.log(str)
				console.log(this.categoryList);
				console.log(this.classifystr);
				console.log(this.classirerslist);
			},
			handleClose(done) {
				this.$confirm('确认取消支付？')
					.then(_ => {
						done();
						clearInterval(this.timer)
					})
					.catch(_ => {});
			},
close(){
	this.dialogVisibless=false
	clearInterval(this.timer)
},
			//生成·二维码
			qrcodeScan() {
				//清楚上次生成二维码
				this.$refs.qrcode.innerHTML = ''
				let qrcode = new QRCode('qrcode', {
					text: this.url,
					width: 150,
					height: 150,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H,
				})
			},
			pay(){
			
				let phone = utils.getSession("shopVo");
				let params = {
					statementNo: this.categoryList,
					itemCode: this.classifystr,
					businessId:phone,
				};
				API.unifiedPreOrder7011(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						// this.dialogVisibles = true,
							this.url = res.data.data.js_pay_url
							this.$nextTick(() => {
								this.qrcodeScan()
							})
							this.merOrderNo=res.data.data.merOrderNo
							this.timer=setInterval(()=>{
								this.getOrderlist()
							},3000)
						// window.open(res.data.data.pc_cashier_url);
						
					} else {}
				});
			},
			//对公
			Pay(){
				let phone = utils.getSession("shopVo");
				let params = {
					statementNo: this.categoryList,
					itemCode: this.classifystr,
					businessId:phone,
				};
				API.unifiedPreOrder9004(params).then((res) => {
					if (res.data.code == 200) {
						console.log("获取合同列表", res);
						this.paylist=res.data.data
						// window.open(res.data.data.pc_cashier_url);	
					} 
				});
			},
			//缴费确认
			confirmation() {
				if (this.val.length == 0) {
					this.$message.error("您还未勾选需要缴费的信息");
				} else {
					this.dialogVisibles=true
					this.paymentTypeChange()
					
				}
			},
getOrderlist(){
	let params = {
		merOrderNo: this.merOrderNo,
	};
	API.getPayRecordByMerOrderNo(params).then((res) => {
		if (res.data.code == 200) {
			console.log("获取合同列表", res.data.data.tradeStatus);
	if(res.data.data.tradeStatus=="SUCCESS"){
		this.lcnk=false,
		this.lnko=true
		this.handleQuery()
	}else{
		this.lcnk=true,
		this.lnko=false
	}
		}
	});
},
			// 查看
			handleView(row) {
				console.log(row);
				// if (!this.$btnResource()["zyht-ck"]) {
				//   this.$message.warning("暂无查看权限");
				//   return;
				// }
				// this.$openTabSwitch(
				//   "自营合同详情",
				//   `/contractNew?actionType=view&contractType=norm&contractId=${row.id}&fromPath=contractList`
				// );
				// this.$router.push({path: '/contract', query: {actionType:'view',contractType:'norm',contractId:row.id}})
			},
			// 历史版本
			// toVersion(scope) {
			//   this.$openTabSwitch(
			//     "自营合同历史版本",
			//     `/versionList?contractType=norm&contractCode=${scope.row.contractCode}&fromPath=contractList`
			//   );
			// },
			// 退租
			// toTuizu(scope) {
			//   this.$openTabSwitch(
			//     "自营合同退租",
			//     `/tuizu?contractType=norm&contractCode=${scope.row.contractCode}&fromPath=contractList&id=${scope.row.id}`
			//   );
			// },
			// 合同终止
			// toStop(scope) {
			//   let { id } = scope.row;
			//   this.$openTabSwitch(
			//     "自营合同终止",
			//     `/refundEdit?contractId=${id}&jumpType=add`
			//   );
			// },
			// 新增
			// handleCreate(scope, actionType, typeName) {
			//   let id = scope ? scope.row.id : "",
			//     contractCode = scope ? scope.row.contractCode : "";
			//   let title = `${typeName}自营合同`;
			//   if (actionType == "renew") {
			//     this.$openTabSwitch(
			//       title,
			//       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}&correlationContractId=${id}&correlationContractCode=${contractCode}`
			//     );
			//   } else if (actionType == "stop") {
			//     this.$openTabSwitch(
			//       title,
			//       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}&correlationContractId=${id}&correlationContractCode=${contractCode}`
			//     );
			//   } else {
			//     this.$openTabSwitch(
			//       title,
			//       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}`
			//     );
			//   }
			// },
			// 审核
			// toApply(flowNo) {
			//   this.$getZjBpmViewUrl(flowNo);
			//   // this.$openTabSwitch2(
			//   //   "",
			//   //   `/workflow/#/flowDetail?processInstanceId=${id}&isBack=true`
			//   // );
			// },
			// 删除  作废
			// openDialog(scope, type) {
			//   this.contractId = scope.row.id;
			//   this.confirmType = type;
			//   this.dialogVisible = true;
			// },
			// 删除  作废  confirm
			async confirm() {
				let res = null;
				if (this.confirmType == "删除") {
					res = await API.delete({
						id: this.contractId
					});
				} else if (this.confirmType == "作废") {
					res = await API.cancel({
						id: this.contractId
					});
				}
				if (res.data.code == 200) {
					this.dialogVisible = false;
					this.handleQuery();
					this.$message.success(`${this.confirmType}成功`);
				}
			},
handleSizeChangess(val) {
				this.pageSizes = val;
				this.getTotalPaidAmount();
			},
		handleSizeChange(val) {
			this.pageSize = val;
			this.handleQuery();
		},
		handleSizeChanges(val) {
			this.pageSizess = val;
			this.getPayRecordList();
		},
		handleCurrentChangess(val) {
			this.pageNums = val;
			if (this.searchForm.beginDate == "") {
				this.getTotalPaidAmount()
			} else
			if (this.nums == 1) {
				this.getTotalPaidAmount()
			} else {
				if (this.searchForm.beginDate !== "") {
					this.getTotalPaidAmount()
				}
			}
		
		
		},
		handleCurrentChange(val) {
			this.pageNum = val;
			if (this.searchForm.beginDate == "") {
				this.handleQuery()
			} else
			if (this.nums == 1) {
				this.handleQuery();
			} else {
				if (this.searchForm.beginDate !== "") {
					this.handleQuerys()
				}
			}
		},
		handleCurrentChanges(val) {
			this.pageNumss = val;
			if (this.searchForm.beginDate == "") {
				this.getPayRecordList()
			} else
			if (this.nums == 1) {
				this.getPayRecordList()
			} else {
				if (this.searchForm.beginDate !== "") {
					this.getPayRecordList()
				}
			}
		
		
		},
			changeSearchFormClose() {
				this.searchFormClose = !this.searchFormClose;
				if (this.searchFormClose) {
					this.ruleForm = this.ruleForm.filter((item) => {
						return !item.allowHide;
					});
				} else {
					this.ruleForm = this.tmpRuleForm;
				}
			},
			mallChange(val) {
				// console.log(val )
				this.$set(this.searchForm, "mallCode", val.mallCode);
				this.$set(this.searchForm, "mallName", val.mallName);
				this.handleQuery();
			},
			changeFloor(val) {
				// console.log(val);
				this.searchForm.buildingId = _.uniq(
					val.map((item) => item.buildingId)
				)[0];
				this.searchForm.floorId = _.uniq(val.map((item) => item.floorId))[0];
			},

			// 渲染搜索条件和table
			renderPage() {
				this.tmpRuleForm = [{
						slot: "mallName"
					},
					{
						slot: 'Billtype'
					},
					{
						slot: 'date'
						
					},
				];
				this.ruleForm = this.tmpRuleForm.filter((item) => {
					return !item.allowHide;
				});
				this.tableColumns = [{
						slot: 'selection'
					},
					{
						type: 'index',
						label: "序号",
						// minWidth: "50px",
						// sortable: true,
					},

					{
						slot: 'boothCode',
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'buildingName'
						// label: "楼栋",
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'floorName'
						// prop: "floorName",
						// label: "楼层",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'statementBeginEndTime'
						// prop: "statementBeginEndTime",
						// label: "账单周期",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "paymentDue"
						// prop: "paymentDue",
						// label: "账单应收日",
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: 'receivableAmount'
						// prop: "receivableAmount",
						// label: "应收金额（元）",
						// // minWidth: "120px",
						// sortable: true,
					},
					{
						// prop: "itemName",
						// label: "费用项",
						slot: 'itemName'
						// minWidth: "120px",
						// sortable: true,
					},
					{
						slot: "contractCode",
					},
					{
						slot: "pay",
					},
					{
						slot: 'dingdan'
					},
					{
						slot: 'jiaoyi'
					},
					{
						slot: 'yinhang'
					},
					{
						slot: 'paytype'
					},
					{
						slot: 'fu'
					},
					{
						slot: 'sou'
					},
					{
						slot: 'status'
					},
					{
						slot: 'times'
					},
				];
			},
		},
	};
</script>
<style lang="less" scoped>
	@import "../../organizationManage/style/index.less";

	/deep/ .rs-table__row {
		&:hover {
			cursor: pointer;
		}
	}

	/deep/ .current-row {
		.resourceCode {
			color: #2ba3ff;
		}
	}

	.contractCode {
		height: 90px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-around;
		background: #f3f7ff;
	}

	.contractCode div {
		text-align: center;
		line-height: 2;
		font-size: 16px;
		margin: 5px;
	}

	.contractCodecolor {
		color: burlywood;
		font-size: 16px;
	}

	.contractCodecolor span {
		font-size: 14px;
	}

	.rs-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.bg-purple-dark {
		background-color: #ffffff;
		color: black;
		font-weight: bold;
		font-size: 15px;
		padding-left: 20px;
		display: flex;
		align-items: center;
	}

	.grid-content {
		/* border-radius: 4px; */
		height: 40px;
		line-height: 40px;
	}

	.main {
		margin-top: 10px;
		padding: 10px;
	}

	.container {
		height: 100%;
		// background-color: #ebebeb;
	}

	.main_header {
		background: white;
		padding: 10px;
		box-shadow: 2px 2px 10px #909090;
	}

	#qrcode {
		width: 150px;
		height: 150px;
		margin: 0 auto;
	}

	#qrcode canvas+img {
		width: 100%;
		height: 100%;
	}
</style>
